export default "__VITE_ASSET__DGAbe9ty__"